import React from 'react';
import { DownloadIcon } from 'lucide-react';
import { Period, Producer } from '../types/commission';
import { PeriodSelect } from './PeriodSelect';
interface DashboardHeaderProps {
  producer: Producer;
  periods: Period[];
  selectedPeriodId: string;
  onSelectPeriod: (periodId: string) => void;
  onExport: () => void;
  isExporting: boolean;
}
export function DashboardHeader({
  producer,
  periods,
  selectedPeriodId,
  onSelectPeriod,
  onExport,
  isExporting
}: DashboardHeaderProps) {
  const selected = periods.find(period => period.id === selectedPeriodId) ?? periods[0];
  return <header className="border-b border-slate-200 bg-white" data-id="element-1" data-mp="wgq0x0zs70kg">
      <div className="mx-auto flex max-w-7xl flex-col gap-5 px-6 py-5 lg:flex-row lg:items-center lg:justify-between" data-id="element-2" data-mp="wjca152blo4s">
        <div className="flex items-center gap-4" data-id="element-3" data-mp="15hy0rnhy49gn">
          <div aria-hidden="true" className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-900 text-sm font-bold tracking-wide text-white" data-id="element-4" data-mp="15j909b4cyv1y">
            {producer.avatarInitials}
          </div>
          <div data-id="element-5" data-mp="3jtm3ef0wzm4g">
            <p className="text-xs font-semibold uppercase tracking-widest text-brand-700" data-id="element-6" data-mp="3jt4bfulabu2c">Loan Commissions</p>
            <h1 className="text-xl font-bold text-slate-900" data-id="element-7" data-mp="3evc7u3ba2jib">{producer.name}</h1>
            <p className="mt-0.5 text-sm text-slate-500" data-id="element-8" data-mp="39vpttrnmkz8g">
              {producer.role} · {producer.branch} · {producer.nmls}
            </p>
          </div>
        </div>

        {isExporting ? <div className="text-left lg:text-right" data-id="element-9" data-mp="6dxzi6m0o373">
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400" data-id="element-10" data-mp="6f99wp9yw976">Commission statement</p>
            <p className="mt-1 text-lg font-bold text-slate-900" data-id="element-11" data-mp="1lelx9nbx82a">{selected.label}</p>
          </div> : <div className="flex flex-wrap items-center gap-3" data-id="element-12" data-mp="u423if34a4ym">
            <PeriodSelect periods={periods} selectedId={selectedPeriodId} onSelect={onSelectPeriod} data-id="element-13" data-mp="u5d3s4xcsukz" />
            <button type="button" onClick={onExport} className="inline-flex items-center gap-2 rounded-lg bg-brand-700 px-3.5 py-2 text-sm font-semibold text-white transition hover:bg-brand-800" data-id="element-14" data-mp="pc0tkztf8qbr">
              <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-15" data-mp="29vw3e6y41f61" />
              Export statement
            </button>
          </div>}
      </div>
    </header>;
}